import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var middleMixin = {
  '&:before': {
    display: 'inline-block',
    height: '100%',
    verticalAlign: 'middle',
    content: '""',
    width: 0
  },
  '& > *': {
    verticalAlign: 'middle'
  }
};
export var isolateMixin = {
  borderCollapse: 'separate',
  borderSpacing: 0,
  borderRadius: 0,
  captionSide: 'top',
  cursor: 'auto',
  direction: 'ltr',
  emptyCells: 'show',
  fontFamily: 'inherit',
  fontSize: 'medium',
  fontStyle: 'normal',
  fontVariant: 'normal',
  fontWeight: 'normal',
  fontStretch: 'normal',
  lineHeight: 'normal',
  verticalAlign: 'baseline',
  hyphens: 'none',
  letterSpacing: 'normal',
  listStyle: 'disc outside none',
  tabSize: '8',
  textAlign: 'left',
  textAlignLast: 'auto',
  textIndent: '0',
  textShadow: 'none',
  textTransform: 'none',
  visibility: 'visible',
  whiteSpace: 'normal',
  widows: '2',
  wordSpacing: 'normal',
  padding: 0,
  margin: 0
};

var responsiveFactory = function responsiveFactory(rule) {
  return function (options) {
    return _defineProperty({}, rule, options);
  };
};

export var ifDesktop = responsiveFactory('@media (min-device-width: 768px)');
export var ifMobile = responsiveFactory('@media (max-device-width: 767px)');
export var ifDesktopWindow = responsiveFactory('@media (min-width: 768px)');
var pseudoSelectors = ['::-webkit-input-placeholder', '::-moz-placeholder', ':-moz-placeholder', ':-ms-input-placeholder', '::placeholder'];
export var placeholderMixin = function placeholderMixin(selector, style) {
  return pseudoSelectors.reduce(function (result, pseudo) {
    return _extends({}, result, _defineProperty({}, "".concat(selector).concat(pseudo), style));
  }, {});
};
export var fontSmoothingMixin = {
  '-webkit-font-smoothing': 'antialiased',
  '-moz-osx-font-smoothing': 'grayscale'
};
/**
 * Applying styles on elements depending on focus event source type
 * @param {string} sourceType Other/pointer
 * @param {string} selector CSS-selector
 * @param {string} declaration CSS-declaration
 */

export var focusSourceMixin = function focusSourceMixin() {
  var sourceType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'other';
  var selector = arguments.length > 1 ? arguments[1] : undefined;
  var declaration = arguments.length > 2 ? arguments[2] : undefined;
  return _defineProperty({}, "html[data-focus-source=\"".concat(sourceType, "\"] ").concat(selector), declaration);
};